export default "__VITE_ASSET__BkGROLoT__"